import { TenantIds } from '@config/tenant-id';
import { EnumSelect } from '@summit/core';

export enum HourlyWorkType {
  General = 0,
  Training = 1,
  Orientation = 2,
  Layover = 3,
  ELD = 4,
  Trainer = 5,
  Trainee = 6
}

export const HourlyWorkTypeMapping: Record<HourlyWorkType, string> = {
  [HourlyWorkType.General]: 'General',
  [HourlyWorkType.Training]: 'Training',
  [HourlyWorkType.Orientation]: 'Orientation',
  [HourlyWorkType.Layover]: 'Layover',
  [HourlyWorkType.ELD]: 'ELD',
  [HourlyWorkType.Trainer]: 'Trainer',
  [HourlyWorkType.Trainee]: 'Trainee'
};
export function GetHourlyWorkTypes(tenantId: string): number[] {
  switch (tenantId?.toUpperCase()) {
    case TenantIds.MEI:
      return EnumSelect.ToIdListExclude(HourlyWorkType, [HourlyWorkType.Training]);
    default:
      return EnumSelect.ToIdListExclude(HourlyWorkType, [HourlyWorkType.Trainer, HourlyWorkType.Trainee]);
  }
}
